import { NgModule } from '@angular/core';
import { GroupValidationDisplayComponent } from './group-validation-display.component';
import { GroupValidationInlineDisplayComponent } from './group-validation-inline-display.component';
import { GroupValidationDirective } from './group-validation.directive';
import { ValidationErrorDirective } from './validation-error.directive';

@NgModule({
	imports: [
		GroupValidationDisplayComponent,
		GroupValidationDirective,
		GroupValidationInlineDisplayComponent,
		ValidationErrorDirective,
	],
	exports: [
		GroupValidationDisplayComponent,
		GroupValidationDirective,
		GroupValidationInlineDisplayComponent,
		ValidationErrorDirective,
	],
})
export class GroupValidationModule {}
